export const getConfirmationDialogState = ({ confirmationDialog }) => confirmationDialog;
